import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { formatDate } from '../../../utils/formatUtils';

const COMPANY_COLORS = {
  headerBg: '5e894f',
  headerFont: 'FFFFFF',
  evenRow: 'E3E6F3',
  oddRow: 'FFFFFF',
};

const buildFileName = () => {
  const now = new Date();
  const date = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(
    now.getDate()
  ).padStart(2, '0')}`;
  const time = `${String(now.getHours()).padStart(2, '0')}-${String(
    now.getMinutes()
  ).padStart(2, '0')}`;
  return `${date}_${time}_facturas_habitat_99.xlsx`;
};

export async function exportInvoicesExcel(invoices = []) {
  if (!Array.isArray(invoices) || invoices.length === 0) return;

  const columns = [
    { header: 'Fecha pago', key: 'payment_date', width: 16 },
    { header: 'Fecha factura', key: 'invoice_date', width: 16 },
    { header: 'Entidad recaudadora', key: 'collector_entity', width: 24 },
    { header: 'Letra', key: 'type_letter', width: 8 },
    { header: 'Pto. venta', key: 'sale_point_number', width: 10 },
    { header: 'Número', key: 'invoice_number', width: 18 },
    { header: 'Cliente', key: 'subscriber_names', width: 30 },
    { header: 'CUIT cliente', key: 'subscriber_cuit', width: 16 },
    { header: 'Neto', key: 'to_net', width: 14 },
    { header: 'Exento', key: 'to_exempt', width: 14 },
    { header: 'IVA', key: 'to_iva', width: 14 },
    { header: 'Total factura', key: 'to_total', width: 16 },
  ];

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Facturas');
  worksheet.columns = columns;

  worksheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: COMPANY_COLORS.headerBg },
    };
    cell.font = {
      color: { argb: COMPANY_COLORS.headerFont },
      bold: true,
      size: 12,
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  invoices.forEach((invoice, idx) => {
    const row = worksheet.addRow({
      payment_date: formatDate(invoice.payment_date),
      invoice_date: formatDate(invoice.invoice_date),
      collector_entity: invoice.collector_entity || '',
      type_letter: invoice.type_letter || '',
      sale_point_number: invoice.sale_point_number || '',
      invoice_number: invoice.invoice_number || '',
      subscriber_names: invoice.subscriber_names || '',
      subscriber_cuit: invoice.subscriber_cuit || '',
      to_net: Number(invoice.to_net || 0),
      to_exempt: Number(invoice.to_exempt || 0),
      to_iva: Number(invoice.to_iva || 0),
      to_total: Number(invoice.to_total || 0),
    });

    row.eachCell((cell, colNumber) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: idx % 2 === 0 ? COMPANY_COLORS.evenRow : COMPANY_COLORS.oddRow },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };

      const isLastCol = colNumber === columns.length;
      cell.border = {
        top: { style: 'thin' },
        bottom: { style: 'thin' },
        ...(isLastCol ? { right: { style: 'thin' } } : {}),
      };

      if ([9, 10, 11, 12].includes(colNumber)) {
        cell.numFmt = '[$$-es-AR] #,##0.00';
      }
      if (cell.value === null || cell.value === undefined) {
        cell.value = '';
      }
    });
  });

  worksheet.columns.forEach((col) => {
    col.width = col.width || 16;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }),
    buildFileName()
  );
}
